export const partnersList = getters => {
  return getters.partnersList
}
